module.exports = __webpack_public_path__ + "static/media/ballot-check.32671128.svg";